import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SamplingDateCalculationStrategy } from './sampling-needs-form/sampling-needs-form.component';
import { TaskType } from '../../../shared/services/projected-task-configuration.service';
import { TissueCollectionType } from '../../../shared/services/request.service';
var SamplingNeedsComponent = /** @class */ (function () {
    function SamplingNeedsComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.tissueTypes = [];
        this.growthStages = [];
        this.tissueCollectionTypes = [];
        this.projectedTaskConfigurations = [];
        this.selectedLaboratoryId = null;
    }
    Object.defineProperty(SamplingNeedsComponent.prototype, "samplingNeeds", {
        get: function () {
            return this.experimentDesignFormGroup.get('requestedSamplings');
        },
        enumerable: true,
        configurable: true
    });
    SamplingNeedsComponent.prototype.addAnalysis = function () {
        var _this = this;
        var lab = this.laboratories.find(function (l) { return l.id === _this.selectedLaboratoryId; });
        if (!lab)
            return;
        var newGroup = this.formBuilder.group({
            laboratory: this.formBuilder.control(lab.id, Validators.required),
            tissueType: this.formBuilder.control(null, Validators.required),
            assay: this.formBuilder.control(null, Validators.required),
            tissueCollectionType: this.formBuilder.control(null, Validators.required),
            samplingDateCalculationStrategy: this.formBuilder.control(SamplingDateCalculationStrategy.GrowthStage),
            growthStage: this.formBuilder.control(null),
            daysAfterPlanting: this.formBuilder.control(null),
            order: this.samplingNeeds.controls.length + 1
        });
        this.samplingNeeds.push(newGroup);
        this.selectedLaboratoryId = null;
    };
    SamplingNeedsComponent.prototype.remove = function (index) {
        this.samplingNeeds.removeAt(index);
        this.samplingNeeds.controls.forEach(function (c, i) {
            c.get('order').setValue(i + 1);
        });
    };
    SamplingNeedsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.laboratories = this.ceRequestOptions
            .laboratories
            .filter(function (l) { return l.isActive; })
            .sort(this.alphabeticalNamedSorter)
            .map(function (l) { return ({
            id: l.id,
            display: l.name
        }); });
        this.projectedTaskConfigurations = this.ceRequestOptions
            .projectedTaskConfigurations
            .filter(function (s) { return s.isActive && s.taskType === TaskType.Sampling && s.cropId === _this.requestDetails.crop; });
        this.growthStages = this.ceRequestOptions
            .growthStages
            .filter(function (l) { return l.isActive; })
            .sort(this.orderFieldSorter)
            .filter(function (g) { return _this.projectedTaskConfigurations.some(function (p) { return p.growthStageId === g.id; }); })
            .map(function (g) { return ({
            id: g.id,
            display: g.name
        }); });
        this.tissueTypes = this.ceRequestOptions
            .tissueTypes
            .filter(function (t) { return t.isActive; })
            .sort(this.alphabeticalNamedSorter)
            .map(function (t) { return ({
            id: t.id,
            display: t.name
        }); });
        this.tissueCollectionTypes = ([TissueCollectionType.Standard, TissueCollectionType.Custom])
            .map(function (tissueCollectionTypeId) { return ({
            id: tissueCollectionTypeId,
            display: TissueCollectionType[tissueCollectionTypeId]
        }); });
    };
    SamplingNeedsComponent.prototype.assaysForLab = function (labId) {
        var labModel = this.ceRequestOptions.laboratories.find(function (f) { return f.id === labId; });
        if (!labModel) {
            return [];
        }
        return labModel
            .assays
            .filter(function (a) { return a.isActive; })
            .map(function (m) { return ({ id: m.id, display: m.name }); });
    };
    SamplingNeedsComponent.prototype.nameOfLab = function (labId) {
        var labModel = this.ceRequestOptions.laboratories.find(function (l) { return l.id === labId; });
        if (!labModel)
            return 'Error';
        return labModel.name;
    };
    SamplingNeedsComponent.prototype.alphabeticalNamedSorter = function (l1, l2) {
        var l1Name = (l1.name || '').toUpperCase();
        var l2Name = (l2.name || '').toUpperCase();
        if (l1Name > l2Name)
            return 1;
        else if (l1Name < l2Name)
            return -1;
        else
            return 0;
    };
    SamplingNeedsComponent.prototype.orderFieldSorter = function (l1, l2) {
        if (l1.order > l2.order)
            return 1;
        else if (l1.order < l2.order)
            return -1;
        else
            return 0;
    };
    return SamplingNeedsComponent;
}());
export { SamplingNeedsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/sampling-needs/sampling-needs.component.ts.pre-build-optimizer.js